@file:OptIn(InternalResourceApi::class)

package one.devsbox.www.www_portal.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/one.devsbox.www.www_portal.generated.resources/"

@delegate:ResourceContentHash(554_570_848)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 10, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 24),
      ))
    }

@delegate:ResourceContentHash(2_075_806_342)
internal val Res.string.campaigns: StringResource by lazy {
      StringResource("string:campaigns", "campaigns", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 35, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35, 29),
      ))
    }

@delegate:ResourceContentHash(-526_566_499)
internal val Res.string.companies: StringResource by lazy {
      StringResource("string:companies", "companies", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 65, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65, 29),
      ))
    }

@delegate:ResourceContentHash(1_031_192_483)
internal val Res.string.devices: StringResource by lazy {
      StringResource("string:devices", "devices", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 91, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 95, 27),
      ))
    }

@delegate:ResourceContentHash(1_067_055_945)
internal val Res.string.dialog_cancel: StringResource by lazy {
      StringResource("string:dialog_cancel", "dialog_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 119, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123, 29),
      ))
    }

@delegate:ResourceContentHash(-1_295_076_463)
internal val Res.string.dialog_ok: StringResource by lazy {
      StringResource("string:dialog_ok", "dialog_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 153, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153, 21),
      ))
    }

@delegate:ResourceContentHash(83_189_163)
internal val Res.string.dow_fri: StringResource by lazy {
      StringResource("string:dow_fri", "dow_fri", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 206, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202, 19),
      ))
    }

@delegate:ResourceContentHash(-1_356_026_652)
internal val Res.string.dow_friday: StringResource by lazy {
      StringResource("string:dow_friday", "dow_friday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 179, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 175, 26),
      ))
    }

@delegate:ResourceContentHash(83_198_065)
internal val Res.string.dow_mon: StringResource by lazy {
      StringResource("string:dow_mon", "dow_mon", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 261, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249, 19),
      ))
    }

@delegate:ResourceContentHash(-653_690_920)
internal val Res.string.dow_monday: StringResource by lazy {
      StringResource("string:dow_monday", "dow_monday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 226, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222, 26),
      ))
    }

@delegate:ResourceContentHash(82_624_385)
internal val Res.string.dow_sat: StringResource by lazy {
      StringResource("string:dow_sat", "dow_sat", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 310, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 302, 19),
      ))
    }

@delegate:ResourceContentHash(102_206_182)
internal val Res.string.dow_saturday: StringResource by lazy {
      StringResource("string:dow_saturday", "dow_saturday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 281, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 269, 32),
      ))
    }

@delegate:ResourceContentHash(83_430_255)
internal val Res.string.dow_sun: StringResource by lazy {
      StringResource("string:dow_sun", "dow_sun", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 361, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 349, 19),
      ))
    }

@delegate:ResourceContentHash(1_455_520_855)
internal val Res.string.dow_sunday: StringResource by lazy {
      StringResource("string:dow_sunday", "dow_sunday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 330, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322, 26),
      ))
    }

@delegate:ResourceContentHash(1_739_283_379)
internal val Res.string.dow_thu: StringResource by lazy {
      StringResource("string:dow_thu", "dow_thu", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 414, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 402, 19),
      ))
    }

@delegate:ResourceContentHash(342_964_421)
internal val Res.string.dow_thursday: StringResource by lazy {
      StringResource("string:dow_thursday", "dow_thursday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 381, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 369, 32),
      ))
    }

@delegate:ResourceContentHash(84_698_146)
internal val Res.string.dow_tue: StringResource by lazy {
      StringResource("string:dow_tue", "dow_tue", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 466, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 454, 19),
      ))
    }

@delegate:ResourceContentHash(335_842_571)
internal val Res.string.dow_tuesday: StringResource by lazy {
      StringResource("string:dow_tuesday", "dow_tuesday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 438, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 422, 31),
      ))
    }

@delegate:ResourceContentHash(82_643_341)
internal val Res.string.dow_wed: StringResource by lazy {
      StringResource("string:dow_wed", "dow_wed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 520, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 508, 19),
      ))
    }

@delegate:ResourceContentHash(1_613_279_074)
internal val Res.string.dow_wednesday: StringResource by lazy {
      StringResource("string:dow_wednesday", "dow_wednesday", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 486, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 474, 33),
      ))
    }

@delegate:ResourceContentHash(0)
internal val Res.string.empty: StringResource by lazy {
      StringResource("string:empty", "empty", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 540, 13),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 528, 13),
      ))
    }

@delegate:ResourceContentHash(-1_977_843_466)
internal val Res.string.locations: StringResource by lazy {
      StringResource("string:locations", "locations", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 554, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 542, 29),
      ))
    }

@delegate:ResourceContentHash(509_354_072)
internal val Res.string.media: StringResource by lazy {
      StringResource("string:media", "media", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 584, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 572, 21),
      ))
    }

@delegate:ResourceContentHash(84_141_902)
internal val Res.string.month_apr: StringResource by lazy {
      StringResource("string:month_apr", "month_apr", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 606, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 594, 21),
      ))
    }

@delegate:ResourceContentHash(80_700_550)
internal val Res.string.month_aug: StringResource by lazy {
      StringResource("string:month_aug", "month_aug", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 628, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 616, 21),
      ))
    }

@delegate:ResourceContentHash(83_232_874)
internal val Res.string.month_dec: StringResource by lazy {
      StringResource("string:month_dec", "month_dec", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 650, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 638, 21),
      ))
    }

@delegate:ResourceContentHash(-1_725_944_460)
internal val Res.string.month_feb: StringResource by lazy {
      StringResource("string:month_feb", "month_feb", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 672, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 660, 21),
      ))
    }

@delegate:ResourceContentHash(82_675_815)
internal val Res.string.month_jan: StringResource by lazy {
      StringResource("string:month_jan", "month_jan", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 698, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 682, 21),
      ))
    }

@delegate:ResourceContentHash(82_674_573)
internal val Res.string.month_jul: StringResource by lazy {
      StringResource("string:month_jul", "month_jul", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 720, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 704, 21),
      ))
    }

@delegate:ResourceContentHash(82_379_548)
internal val Res.string.month_jun: StringResource by lazy {
      StringResource("string:month_jun", "month_jun", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 742, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 726, 21),
      ))
    }

@delegate:ResourceContentHash(-1_457_312_143)
internal val Res.string.month_mar: StringResource by lazy {
      StringResource("string:month_mar", "month_mar", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 764, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 748, 21),
      ))
    }

@delegate:ResourceContentHash(82_696_862)
internal val Res.string.month_may: StringResource by lazy {
      StringResource("string:month_may", "month_may", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 790, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 770, 21),
      ))
    }

@delegate:ResourceContentHash(82_707_957)
internal val Res.string.month_nov: StringResource by lazy {
      StringResource("string:month_nov", "month_nov", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 812, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 792, 21),
      ))
    }

@delegate:ResourceContentHash(82_351_455)
internal val Res.string.month_oct: StringResource by lazy {
      StringResource("string:month_oct", "month_oct", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 834, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 814, 21),
      ))
    }

@delegate:ResourceContentHash(84_445_514)
internal val Res.string.month_sep: StringResource by lazy {
      StringResource("string:month_sep", "month_sep", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 856, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 836, 21),
      ))
    }

@delegate:ResourceContentHash(-2_114_660_715)
internal val Res.string.moto: StringResource by lazy {
      StringResource("string:moto", "moto", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 878, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 858, 48),
      ))
    }

@delegate:ResourceContentHash(83_454_045)
internal val Res.string.no: StringResource by lazy {
      StringResource("string:no", "no", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 931, 14),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 907, 14),
      ))
    }

@delegate:ResourceContentHash(-1_804_561_790)
internal val Res.string.string_ui_locations_detail_devices_empty: StringResource by lazy {
      StringResource("string:string_ui_locations_detail_devices_empty", "string_ui_locations_detail_devices_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 946, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 922, 92),
      ))
    }

@delegate:ResourceContentHash(-1_084_092_026)
internal val Res.string.ui_action_add: StringResource by lazy {
      StringResource("string:ui_action_add", "ui_action_add", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1035, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1015, 25),
      ))
    }

@delegate:ResourceContentHash(-251_236_139)
internal val Res.string.ui_action_change: StringResource by lazy {
      StringResource("string:ui_action_change", "ui_action_change", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1065, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1041, 32),
      ))
    }

@delegate:ResourceContentHash(881_315_651)
internal val Res.string.ui_action_delete: StringResource by lazy {
      StringResource("string:ui_action_delete", "ui_action_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1102, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1074, 32),
      ))
    }

@delegate:ResourceContentHash(546_863_784)
internal val Res.string.ui_action_view: StringResource by lazy {
      StringResource("string:ui_action_view", "ui_action_view", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1139, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1107, 30),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_campaigns_detail_btn_delete: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_btn_delete", "ui_campaigns_detail_btn_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1174, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1138, 46),
      ))
    }

@delegate:ResourceContentHash(-503_216_827)
internal val Res.string.ui_campaigns_detail_btn_edit: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_btn_edit", "ui_campaigns_detail_btn_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1225, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1185, 44),
      ))
    }

@delegate:ResourceContentHash(-109_023_434)
internal val Res.string.ui_campaigns_detail_btn_pause: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_btn_pause", "ui_campaigns_detail_btn_pause", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1270, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1230, 45),
      ))
    }

@delegate:ResourceContentHash(1_765_233_829)
internal val Res.string.ui_campaigns_detail_btn_resume: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_btn_resume", "ui_campaigns_detail_btn_resume", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1320, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1276, 46),
      ))
    }

@delegate:ResourceContentHash(376_450_631)
internal val Res.string.ui_campaigns_detail_device_cluster: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_device_cluster", "ui_campaigns_detail_device_cluster", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1371, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1323, 62),
      ))
    }

@delegate:ResourceContentHash(-1_767_816_274)
internal val Res.string.ui_campaigns_detail_geo_nodes: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_geo_nodes", "ui_campaigns_detail_geo_nodes", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1438, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1386, 49),
      ))
    }

@delegate:ResourceContentHash(-1_385_651_888)
internal val Res.string.ui_campaigns_detail_locations: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_locations", "ui_campaigns_detail_locations", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1492, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1436, 49),
      ))
    }

@delegate:ResourceContentHash(1_559_678_106)
internal val Res.string.ui_campaigns_detail_media_assets: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_media_assets", "ui_campaigns_detail_media_assets", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1542, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1486, 56),
      ))
    }

@delegate:ResourceContentHash(1_102_380_134)
internal val Res.string.ui_campaigns_detail_overview: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_overview", "ui_campaigns_detail_overview", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1607, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1543, 48),
      ))
    }

@delegate:ResourceContentHash(-2_053_283_646)
internal val Res.string.ui_campaigns_detail_reach_estimate: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_reach_estimate", "ui_campaigns_detail_reach_estimate", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1656, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1592, 62),
      ))
    }

@delegate:ResourceContentHash(-1_315_232_960)
internal val Res.string.ui_campaigns_detail_status: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_status", "ui_campaigns_detail_status", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1719, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1655, 42),
      ))
    }

@delegate:ResourceContentHash(1_221_190_687)
internal val Res.string.ui_campaigns_detail_total_assets: StringResource by lazy {
      StringResource("string:ui_campaigns_detail_total_assets", "ui_campaigns_detail_total_assets", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1762, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1698, 56),
      ))
    }

@delegate:ResourceContentHash(1_811_251_413)
internal val Res.string.ui_campaigns_edit_activation_date: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_activation_date", "ui_campaigns_edit_activation_date", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1823, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1755, 61),
      ))
    }

@delegate:ResourceContentHash(1_449_379_509)
internal val Res.string.ui_campaigns_edit_assets_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_assets_title", "ui_campaigns_edit_assets_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1889, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1817, 46),
      ))
    }

@delegate:ResourceContentHash(-267_574_627)
internal val Res.string.ui_campaigns_edit_btn_activate: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_activate", "ui_campaigns_edit_btn_activate", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 1940, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1864, 62),
      ))
    }

@delegate:ResourceContentHash(-1_807_433_538)
internal val Res.string.ui_campaigns_edit_btn_back: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_back", "ui_campaigns_edit_btn_back", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2003, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1927, 42),
      ))
    }

@delegate:ResourceContentHash(-133_818_720)
internal val Res.string.ui_campaigns_edit_btn_clear: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_clear", "ui_campaigns_edit_btn_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2046, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1970, 43),
      ))
    }

@delegate:ResourceContentHash(-1_594_403_747)
internal val Res.string.ui_campaigns_edit_btn_close: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_close", "ui_campaigns_edit_btn_close", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2094, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2014, 43),
      ))
    }

@delegate:ResourceContentHash(-697_943_661)
internal val Res.string.ui_campaigns_edit_btn_pick_assets: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_pick_assets", "ui_campaigns_edit_btn_pick_assets", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2142, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2058, 57),
      ))
    }

@delegate:ResourceContentHash(-1_176_198_193)
internal val Res.string.ui_campaigns_edit_btn_pick_locations: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_pick_locations", "ui_campaigns_edit_btn_pick_locations", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2204, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2116, 64),
      ))
    }

@delegate:ResourceContentHash(907_211_613)
internal val Res.string.ui_campaigns_edit_btn_save_draft: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_save_draft", "ui_campaigns_edit_btn_save_draft", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2273, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2181, 60),
      ))
    }

@delegate:ResourceContentHash(-281_068_966)
internal val Res.string.ui_campaigns_edit_btn_select_all: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_select_all", "ui_campaigns_edit_btn_select_all", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2338, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2242, 56),
      ))
    }

@delegate:ResourceContentHash(1_474_369_607)
internal val Res.string.ui_campaigns_edit_btn_unselect_all: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_btn_unselect_all", "ui_campaigns_edit_btn_unselect_all", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2395, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2299, 58),
      ))
    }

@delegate:ResourceContentHash(873_502_057)
internal val Res.string.ui_campaigns_edit_campaign_name: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_campaign_name", "ui_campaigns_edit_campaign_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2550, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2438, 59),
      ))
    }

@delegate:ResourceContentHash(1_440_206_068)
internal val Res.string.ui_campaigns_edit_campaign_name_placeholder: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_campaign_name_placeholder", "ui_campaigns_edit_campaign_name_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2466, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2358, 79),
      ))
    }

@delegate:ResourceContentHash(-2_006_097_926)
internal val Res.string.ui_campaigns_edit_commencement: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_commencement", "ui_campaigns_edit_commencement", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2610, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2498, 54),
      ))
    }

@delegate:ResourceContentHash(-1_181_280_874)
internal val Res.string.ui_campaigns_edit_deployment_zone: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_deployment_zone", "ui_campaigns_edit_deployment_zone", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2661, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2553, 61),
      ))
    }

@delegate:ResourceContentHash(1_032_257_010)
internal val Res.string.ui_campaigns_edit_duration_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_duration_desc", "ui_campaigns_edit_duration_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2727, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2615, 159),
      ))
    }

@delegate:ResourceContentHash(701_721_428)
internal val Res.string.ui_campaigns_edit_duration_field_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_duration_field_desc", "ui_campaigns_edit_duration_field_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 2895, 261),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2775, 269),
      ))
    }

@delegate:ResourceContentHash(396_888_822)
internal val Res.string.ui_campaigns_edit_duration_field_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_duration_field_title", "ui_campaigns_edit_duration_field_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3157, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3045, 82),
      ))
    }

@delegate:ResourceContentHash(96_004_440)
internal val Res.string.ui_campaigns_edit_duration_seconds_suffix: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_duration_seconds_suffix", "ui_campaigns_edit_duration_seconds_suffix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3244, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3128, 53),
      ))
    }

@delegate:ResourceContentHash(1_132_501_738)
internal val Res.string.ui_campaigns_edit_duration_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_duration_title", "ui_campaigns_edit_duration_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3298, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3182, 52),
      ))
    }

@delegate:ResourceContentHash(-569_596_359)
internal val Res.string.ui_campaigns_edit_expiration_date: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_expiration_date", "ui_campaigns_edit_expiration_date", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3351, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3235, 61),
      ))
    }

@delegate:ResourceContentHash(-353_145_663)
internal val Res.string.ui_campaigns_edit_identity_schedule: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_identity_schedule", "ui_campaigns_edit_identity_schedule", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3409, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3297, 71),
      ))
    }

@delegate:ResourceContentHash(-531_875_519)
internal val Res.string.ui_campaigns_edit_immediate: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_immediate", "ui_campaigns_edit_immediate", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3481, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3369, 47),
      ))
    }

@delegate:ResourceContentHash(-1_050_558_054)
internal val Res.string.ui_campaigns_edit_locations_selected: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_locations_selected", "ui_campaigns_edit_locations_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3525, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3417, 68),
      ))
    }

@delegate:ResourceContentHash(-1_385_651_888)
internal val Res.string.ui_campaigns_edit_locations_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_locations_title", "ui_campaigns_edit_locations_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3594, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3486, 53),
      ))
    }

@delegate:ResourceContentHash(421_593_902)
internal val Res.string.ui_campaigns_edit_no_locations_found: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_no_locations_found", "ui_campaigns_edit_no_locations_found", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3648, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3540, 100),
      ))
    }

@delegate:ResourceContentHash(-954_332_803)
internal val Res.string.ui_campaigns_edit_nodes: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_nodes", "ui_campaigns_edit_nodes", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3828, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3696, 39),
      ))
    }

@delegate:ResourceContentHash(-55_599_751)
internal val Res.string.ui_campaigns_edit_nodes_active: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_nodes_active", "ui_campaigns_edit_nodes_active", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3765, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3641, 54),
      ))
    }

@delegate:ResourceContentHash(-220_012_296)
internal val Res.string.ui_campaigns_edit_nomenclature_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_nomenclature_desc", "ui_campaigns_edit_nomenclature_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 3872, 219),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3736, 219),
      ))
    }

@delegate:ResourceContentHash(-862_359_620)
internal val Res.string.ui_campaigns_edit_nomenclature_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_nomenclature_title", "ui_campaigns_edit_nomenclature_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4092, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3956, 60),
      ))
    }

@delegate:ResourceContentHash(543_457_831)
internal val Res.string.ui_campaigns_edit_perpetual: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_perpetual", "ui_campaigns_edit_perpetual", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4153, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4017, 47),
      ))
    }

@delegate:ResourceContentHash(-1_126_320_535)
internal val Res.string.ui_campaigns_edit_primary_designation: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_primary_designation", "ui_campaigns_edit_primary_designation", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4197, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4065, 73),
      ))
    }

@delegate:ResourceContentHash(-403_237_092)
internal val Res.string.ui_campaigns_edit_scheduling_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_scheduling_desc", "ui_campaigns_edit_scheduling_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4263, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4139, 157),
      ))
    }

@delegate:ResourceContentHash(2_029_462_745)
internal val Res.string.ui_campaigns_edit_scheduling_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_scheduling_title", "ui_campaigns_edit_scheduling_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4417, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4297, 58),
      ))
    }

@delegate:ResourceContentHash(165_300_970)
internal val Res.string.ui_campaigns_edit_search_placeholder: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_search_placeholder", "ui_campaigns_edit_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4472, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4356, 88),
      ))
    }

@delegate:ResourceContentHash(-1_169_956_721)
internal val Res.string.ui_campaigns_edit_select_from_library: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_select_from_library", "ui_campaigns_edit_select_from_library", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4692, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4548, 73),
      ))
    }

@delegate:ResourceContentHash(952_150_861)
internal val Res.string.ui_campaigns_edit_select_from_library_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_select_from_library_desc", "ui_campaigns_edit_select_from_library_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4577, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4445, 102),
      ))
    }

@delegate:ResourceContentHash(-841_910_432)
internal val Res.string.ui_campaigns_edit_step_format: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_step_format", "ui_campaigns_edit_step_format", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4766, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4622, 45),
      ))
    }

@delegate:ResourceContentHash(2_082_368_184)
internal val Res.string.ui_campaigns_edit_targeting_requirements_desc: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_targeting_requirements_desc", "ui_campaigns_edit_targeting_requirements_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 4812, 501),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4668, 453),
      ))
    }

@delegate:ResourceContentHash(1_133_861)
internal val Res.string.ui_campaigns_edit_targeting_requirements_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_targeting_requirements_title", "ui_campaigns_edit_targeting_requirements_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5314, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5122, 86),
      ))
    }

@delegate:ResourceContentHash(1_180_400_046)
internal val Res.string.ui_campaigns_edit_targeting_summary: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_targeting_summary", "ui_campaigns_edit_targeting_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5393, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5209, 67),
      ))
    }

@delegate:ResourceContentHash(-1_378_167_346)
internal val Res.string.ui_campaigns_edit_temporal_parameters: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_temporal_parameters", "ui_campaigns_edit_temporal_parameters", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5461, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5277, 73),
      ))
    }

@delegate:ResourceContentHash(-2_003_870_425)
internal val Res.string.ui_campaigns_edit_termination: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_termination", "ui_campaigns_edit_termination", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5535, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5351, 53),
      ))
    }

@delegate:ResourceContentHash(-433_275_553)
internal val Res.string.ui_campaigns_edit_title: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_title", "ui_campaigns_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5589, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5405, 51),
      ))
    }

@delegate:ResourceContentHash(1_187_313_072)
internal val Res.string.ui_campaigns_edit_visual_guidelines_multiple: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_visual_guidelines_multiple", "ui_campaigns_edit_visual_guidelines_multiple", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 5645, 776),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5457, 704),
      ))
    }

@delegate:ResourceContentHash(1_859_646_285)
internal val Res.string.ui_campaigns_edit_visual_guidelines_single: StringResource by lazy {
      StringResource("string:ui_campaigns_edit_visual_guidelines_single", "ui_campaigns_edit_visual_guidelines_single", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 6422, 546),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6162, 518),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("campaigns", Res.string.campaigns)
  map.put("companies", Res.string.companies)
  map.put("devices", Res.string.devices)
  map.put("dialog_cancel", Res.string.dialog_cancel)
  map.put("dialog_ok", Res.string.dialog_ok)
  map.put("dow_fri", Res.string.dow_fri)
  map.put("dow_friday", Res.string.dow_friday)
  map.put("dow_mon", Res.string.dow_mon)
  map.put("dow_monday", Res.string.dow_monday)
  map.put("dow_sat", Res.string.dow_sat)
  map.put("dow_saturday", Res.string.dow_saturday)
  map.put("dow_sun", Res.string.dow_sun)
  map.put("dow_sunday", Res.string.dow_sunday)
  map.put("dow_thu", Res.string.dow_thu)
  map.put("dow_thursday", Res.string.dow_thursday)
  map.put("dow_tue", Res.string.dow_tue)
  map.put("dow_tuesday", Res.string.dow_tuesday)
  map.put("dow_wed", Res.string.dow_wed)
  map.put("dow_wednesday", Res.string.dow_wednesday)
  map.put("empty", Res.string.empty)
  map.put("locations", Res.string.locations)
  map.put("media", Res.string.media)
  map.put("month_apr", Res.string.month_apr)
  map.put("month_aug", Res.string.month_aug)
  map.put("month_dec", Res.string.month_dec)
  map.put("month_feb", Res.string.month_feb)
  map.put("month_jan", Res.string.month_jan)
  map.put("month_jul", Res.string.month_jul)
  map.put("month_jun", Res.string.month_jun)
  map.put("month_mar", Res.string.month_mar)
  map.put("month_may", Res.string.month_may)
  map.put("month_nov", Res.string.month_nov)
  map.put("month_oct", Res.string.month_oct)
  map.put("month_sep", Res.string.month_sep)
  map.put("moto", Res.string.moto)
  map.put("no", Res.string.no)
  map.put("string_ui_locations_detail_devices_empty", Res.string.string_ui_locations_detail_devices_empty)
  map.put("ui_action_add", Res.string.ui_action_add)
  map.put("ui_action_change", Res.string.ui_action_change)
  map.put("ui_action_delete", Res.string.ui_action_delete)
  map.put("ui_action_view", Res.string.ui_action_view)
  map.put("ui_campaigns_detail_btn_delete", Res.string.ui_campaigns_detail_btn_delete)
  map.put("ui_campaigns_detail_btn_edit", Res.string.ui_campaigns_detail_btn_edit)
  map.put("ui_campaigns_detail_btn_pause", Res.string.ui_campaigns_detail_btn_pause)
  map.put("ui_campaigns_detail_btn_resume", Res.string.ui_campaigns_detail_btn_resume)
  map.put("ui_campaigns_detail_device_cluster", Res.string.ui_campaigns_detail_device_cluster)
  map.put("ui_campaigns_detail_geo_nodes", Res.string.ui_campaigns_detail_geo_nodes)
  map.put("ui_campaigns_detail_locations", Res.string.ui_campaigns_detail_locations)
  map.put("ui_campaigns_detail_media_assets", Res.string.ui_campaigns_detail_media_assets)
  map.put("ui_campaigns_detail_overview", Res.string.ui_campaigns_detail_overview)
  map.put("ui_campaigns_detail_reach_estimate", Res.string.ui_campaigns_detail_reach_estimate)
  map.put("ui_campaigns_detail_status", Res.string.ui_campaigns_detail_status)
  map.put("ui_campaigns_detail_total_assets", Res.string.ui_campaigns_detail_total_assets)
  map.put("ui_campaigns_edit_activation_date", Res.string.ui_campaigns_edit_activation_date)
  map.put("ui_campaigns_edit_assets_title", Res.string.ui_campaigns_edit_assets_title)
  map.put("ui_campaigns_edit_btn_activate", Res.string.ui_campaigns_edit_btn_activate)
  map.put("ui_campaigns_edit_btn_back", Res.string.ui_campaigns_edit_btn_back)
  map.put("ui_campaigns_edit_btn_clear", Res.string.ui_campaigns_edit_btn_clear)
  map.put("ui_campaigns_edit_btn_close", Res.string.ui_campaigns_edit_btn_close)
  map.put("ui_campaigns_edit_btn_pick_assets", Res.string.ui_campaigns_edit_btn_pick_assets)
  map.put("ui_campaigns_edit_btn_pick_locations", Res.string.ui_campaigns_edit_btn_pick_locations)
  map.put("ui_campaigns_edit_btn_save_draft", Res.string.ui_campaigns_edit_btn_save_draft)
  map.put("ui_campaigns_edit_btn_select_all", Res.string.ui_campaigns_edit_btn_select_all)
  map.put("ui_campaigns_edit_btn_unselect_all", Res.string.ui_campaigns_edit_btn_unselect_all)
  map.put("ui_campaigns_edit_campaign_name", Res.string.ui_campaigns_edit_campaign_name)
  map.put("ui_campaigns_edit_campaign_name_placeholder", Res.string.ui_campaigns_edit_campaign_name_placeholder)
  map.put("ui_campaigns_edit_commencement", Res.string.ui_campaigns_edit_commencement)
  map.put("ui_campaigns_edit_deployment_zone", Res.string.ui_campaigns_edit_deployment_zone)
  map.put("ui_campaigns_edit_duration_desc", Res.string.ui_campaigns_edit_duration_desc)
  map.put("ui_campaigns_edit_duration_field_desc", Res.string.ui_campaigns_edit_duration_field_desc)
  map.put("ui_campaigns_edit_duration_field_title", Res.string.ui_campaigns_edit_duration_field_title)
  map.put("ui_campaigns_edit_duration_seconds_suffix", Res.string.ui_campaigns_edit_duration_seconds_suffix)
  map.put("ui_campaigns_edit_duration_title", Res.string.ui_campaigns_edit_duration_title)
  map.put("ui_campaigns_edit_expiration_date", Res.string.ui_campaigns_edit_expiration_date)
  map.put("ui_campaigns_edit_identity_schedule", Res.string.ui_campaigns_edit_identity_schedule)
  map.put("ui_campaigns_edit_immediate", Res.string.ui_campaigns_edit_immediate)
  map.put("ui_campaigns_edit_locations_selected", Res.string.ui_campaigns_edit_locations_selected)
  map.put("ui_campaigns_edit_locations_title", Res.string.ui_campaigns_edit_locations_title)
  map.put("ui_campaigns_edit_no_locations_found", Res.string.ui_campaigns_edit_no_locations_found)
  map.put("ui_campaigns_edit_nodes", Res.string.ui_campaigns_edit_nodes)
  map.put("ui_campaigns_edit_nodes_active", Res.string.ui_campaigns_edit_nodes_active)
  map.put("ui_campaigns_edit_nomenclature_desc", Res.string.ui_campaigns_edit_nomenclature_desc)
  map.put("ui_campaigns_edit_nomenclature_title", Res.string.ui_campaigns_edit_nomenclature_title)
  map.put("ui_campaigns_edit_perpetual", Res.string.ui_campaigns_edit_perpetual)
  map.put("ui_campaigns_edit_primary_designation", Res.string.ui_campaigns_edit_primary_designation)
  map.put("ui_campaigns_edit_scheduling_desc", Res.string.ui_campaigns_edit_scheduling_desc)
  map.put("ui_campaigns_edit_scheduling_title", Res.string.ui_campaigns_edit_scheduling_title)
  map.put("ui_campaigns_edit_search_placeholder", Res.string.ui_campaigns_edit_search_placeholder)
  map.put("ui_campaigns_edit_select_from_library", Res.string.ui_campaigns_edit_select_from_library)
  map.put("ui_campaigns_edit_select_from_library_desc", Res.string.ui_campaigns_edit_select_from_library_desc)
  map.put("ui_campaigns_edit_step_format", Res.string.ui_campaigns_edit_step_format)
  map.put("ui_campaigns_edit_targeting_requirements_desc", Res.string.ui_campaigns_edit_targeting_requirements_desc)
  map.put("ui_campaigns_edit_targeting_requirements_title", Res.string.ui_campaigns_edit_targeting_requirements_title)
  map.put("ui_campaigns_edit_targeting_summary", Res.string.ui_campaigns_edit_targeting_summary)
  map.put("ui_campaigns_edit_temporal_parameters", Res.string.ui_campaigns_edit_temporal_parameters)
  map.put("ui_campaigns_edit_termination", Res.string.ui_campaigns_edit_termination)
  map.put("ui_campaigns_edit_title", Res.string.ui_campaigns_edit_title)
  map.put("ui_campaigns_edit_visual_guidelines_multiple", Res.string.ui_campaigns_edit_visual_guidelines_multiple)
  map.put("ui_campaigns_edit_visual_guidelines_single", Res.string.ui_campaigns_edit_visual_guidelines_single)
}
